import { ChakraStylesConfig } from "chakra-react-select";

export const chakraStyles: ChakraStylesConfig<any> = {
  dropdownIndicator: (provided) => ({
    ...provided,
    background: "darkBrown.300",
    color: "white",
  }),
};
